import { BaseService } from 'src/app/shared/services/base-service.service';
import { ApiResponse } from 'src/app/shared/models/api-response.model';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AttachmentDto } from '../common/attachment/attachment';
@Injectable({
  providedIn: 'root'
})
export class AttachementService extends BaseService {
  constructor(private http: HttpClient) {
    super();
   }
    upload(file:FormData): Observable<ApiResponse<any>> {
    return this.http.post<ApiResponse<any>>(`/api/Attachment/Upload/`, file)
      .pipe(
        catchError(this.handleError)
      )
  }
  saveupload(file:FormData,option:any) {
    return this.http.post(`/api/Attachment/SaveUpload/`, file, option)
      .pipe(
        catchError(this.handleError)
      )
  }
  download(id: string) {
    return this.http.post(`/api/Attachment/Download?id=${id}`,'')
      .pipe(
        catchError(this.handleError)
      )
  }
  Deleteattachment(id: string) {
    return this.http.post(`/api/Attachment/DeleteAttachementAsync?id=${id}`,'')
      .pipe(
        catchError(this.handleError)
      )
  }

  get(id: string): Observable<AttachmentDto> {
    return this.http.get<AttachmentDto>("/api/Attachment/" + id);
  }

  static base64ToBlob(b64Data, contentType = '', sliceSize = 512) {
    b64Data = b64Data.replace(/\s/g, ''); //IE compatibility...
    let byteCharacters = atob(b64Data);
    let byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);

      let byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: contentType });
  }
}














